define("shared/components/shared/wizards/credentials/connect-fb", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@close}} as |modal|>
    <modal.card class="o--modalCard tOB--modalCard">
      <modal.card-body class="u--p__t__0 tOB--wizard">
        <div class="tOB--wizard__left">
          <figure class="o--mediaContainer">
            <img class="o--media" src="/assets/images/img--ob__autoPublish.png" />
            <b class="o--mediaOverlay"></b>
          </figure>
        </div>
        <div class="tOB--wizard__right">
          <div class="tOB--wizard__contentWrapper">
            <h2 class="tOB--wizard__title">
              {{t "influencers.fb_permission.title"}}
            </h2>
            <p class="tOB--wizard__subtitle">
              {{html-safe (t "onboarding.auto_publishing.desc")}}
            </p>
            <ul class="tOB--wizard__ul--sm">
              <li class="tOB--wizard__li">
                {{t "onboarding.auto_publishing.tutorial_step_1"}}
                <Shared::Link
                  @href="https://www.facebook.com/help/1148909221857370"
                  @text={{t "shared_phrases.learn_more"}}
                  {{track "clicked-fb-help-onboarding" "click"}}
                />
              </li>
              <li class="tOB--wizard__li">
                {{t "onboarding.auto_publishing.tutorial_step_2"}}
                <Shared::Link
                  @href="https://www.facebook.com/help/510247025775149?helpref=faq_content"
                  @text={{t "onboarding.auto_publishing.check_role"}}
                  {{track "clicked-fb-check-role-onboarding" "click"}}
                />
              </li>
              <li class="tOB--wizard__li u--text--bold">
                {{t "onboarding.auto_publishing.tutorial_step_3"}}
              </li>
            </ul>
          </div>
          <Shared::Ui::Button
            @additional="block"
            @text={{t "influencers.fb_permission.btn_text"}}
            {{on "click" (perform @connectFacebook)}}
          />
        </div>
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "bQX+GyB3",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"o--modalCard tOB--modalCard\"]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0 tOB--wizard\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"tOB--wizard__left\"],[12],[1,\"\\n        \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n          \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--ob__autoPublish.png\"],[12],[13],[1,\"\\n          \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tOB--wizard__right\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tOB--wizard__contentWrapper\"],[12],[1,\"\\n          \"],[10,\"h2\"],[14,0,\"tOB--wizard__title\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"influencers.fb_permission.title\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"tOB--wizard__subtitle\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[[28,[37,1],[\"onboarding.auto_publishing.desc\"],null]],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"ul\"],[14,0,\"tOB--wizard__ul--sm\"],[12],[1,\"\\n            \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"onboarding.auto_publishing.tutorial_step_1\"],null]],[1,\"\\n              \"],[8,[39,3],[[4,[38,4],[\"clicked-fb-help-onboarding\",\"click\"],null]],[[\"@href\",\"@text\"],[\"https://www.facebook.com/help/1148909221857370\",[28,[37,1],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"li\"],[14,0,\"tOB--wizard__li\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"onboarding.auto_publishing.tutorial_step_2\"],null]],[1,\"\\n              \"],[8,[39,3],[[4,[38,4],[\"clicked-fb-check-role-onboarding\",\"click\"],null]],[[\"@href\",\"@text\"],[\"https://www.facebook.com/help/510247025775149?helpref=faq_content\",[28,[37,1],[\"onboarding.auto_publishing.check_role\"],null]]],null],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"li\"],[14,0,\"tOB--wizard__li u--text--bold\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"onboarding.auto_publishing.tutorial_step_3\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,5],[[4,[38,6],[\"click\",[28,[37,7],[[30,3]],null]],null]],[[\"@additional\",\"@text\"],[\"block\",[28,[37,1],[\"influencers.fb_permission.btn_text\"],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@close\",\"modal\",\"@connectFacebook\"],false,[\"shared/modal\",\"t\",\"html-safe\",\"shared/link\",\"track\",\"shared/ui/button\",\"on\",\"perform\"]]",
    "moduleName": "shared/components/shared/wizards/credentials/connect-fb.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});